var installedModules = {};
var moduleToHandlerMapping = {
	78286: {
		getter: () => (() => (__webpack_require__(96540))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.3.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	56370: {
		getter: () => (() => (__webpack_require__(40961))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.3.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	1973: {
		getter: () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-router-dom_dist_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom")]).then(() => (() => (__webpack_require__(92648))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "6.28.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	},
	81217: {
		getter: () => (() => (__webpack_require__(32389))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "15.1.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-i18next",
	},
	65201: {
		getter: () => (() => (__webpack_require__(72635))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "24.0.5",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "i18next",
	},
	73780: {
		getter: () => (Promise.all([__webpack_require__.e("vendors-node_modules_highcharts_modules_accessibility_js-node_modules_highcharts_modules_sank-fe3811"), __webpack_require__.e("webpack_sharing_consume_default_clsx_clsx-webpack_sharing_consume_default_date-fns_date-fns"), __webpack_require__.e("libs_sds_src_index_ts")]).then(() => (() => (__webpack_require__(8925))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "1.5.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@squiz/sds",
	},
	98987: {
		getter: () => (__webpack_require__.e("node_modules_clsx_dist_clsx_mjs").then(() => (() => (__webpack_require__(34164))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.1.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "clsx",
	},
	99277: {
		getter: () => (__webpack_require__.e("vendors-node_modules_date-fns_index_js").then(() => (() => (__webpack_require__(44353))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.1.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "date-fns",
	},
	27897: {
		getter: () => (__webpack_require__.e("vendors-node_modules_rxjs_dist_esm5_index_js").then(() => (() => (__webpack_require__(95057))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.8.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "rxjs",
	},
	73385: {
		getter: () => (__webpack_require__.e("vendors-node_modules_semver_index_js").then(() => (() => (__webpack_require__(99589))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.6.3",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "semver",
	},
	44213: {
		getter: () => (Promise.all([__webpack_require__.e("vendors-node_modules_lodash__baseMerge_js-node_modules_lodash__createAssigner_js"), __webpack_require__.e("vendors-node_modules_atob_browser-atob_js-node_modules_btoa_index_js-node_modules_lodash_debo-756403"), __webpack_require__.e("packages_dxp-console-support_dist_mjs_index_js")]).then(() => (() => (__webpack_require__(8380))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "1.8.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@squiz/dxp-console-support",
	},
	64153: {
		getter: () => (__webpack_require__.e("vendors-node_modules_tanstack_react-table_build_lib_index_mjs").then(() => (() => (__webpack_require__(59233))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "8.20.5",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@tanstack/react-table",
	},
	80076: {
		getter: () => (__webpack_require__.e("vendors-node_modules_lodash_lodash_js").then(() => (() => (__webpack_require__(2543))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.17.21",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "lodash",
	},
	58777: {
		getter: () => (__webpack_require__.e("vendors-node_modules_highcharts_highcharts_js").then(() => (() => (__webpack_require__(14783))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "11.0.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "highcharts",
	},
	97749: {
		getter: () => (__webpack_require__.e("node_modules_highcharts-react-official_dist_highcharts-react_min_js").then(() => (() => (__webpack_require__(85316))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "3.2.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "highcharts-react-official",
	},
	94743: {
		getter: () => (__webpack_require__.e("vendors-node_modules_prismjs_prism_js").then(() => (() => (__webpack_require__(28848))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "1.29.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "prismjs",
	},
	50666: {
		getter: () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-js-cron_dist_esm_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom")]).then(() => (() => (__webpack_require__(57711))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.0.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-js-cron",
	},
	83402: {
		getter: () => (__webpack_require__.e("vendors-node_modules_easepick_bundle_dist_index_esm_js").then(() => (() => (__webpack_require__(72975))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "1.2.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@easepick/bundle",
	},
	81341: {
		getter: () => (__webpack_require__.e("vendors-node_modules_react-ease-picker_dist_module_js").then(() => (() => (__webpack_require__(27471))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.19",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-ease-picker",
	},
	43638: {
		getter: () => (__webpack_require__.e("vendors-node_modules_focus-trap-react_dist_focus-trap-react_js").then(() => (() => (__webpack_require__(94708))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "10.3.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "focus-trap-react",
	},
	82013: {
		getter: () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-transition-group_esm_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom")]).then(() => (() => (__webpack_require__(27875))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.4.5",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-transition-group",
	},
	48295: {
		getter: () => (__webpack_require__.e("node_modules_zustand_esm_index_mjs").then(() => (() => (__webpack_require__(81621))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.5.5",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "zustand",
	},
	62204: {
		getter: () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-beautiful-dnd_dist_react-beautiful-dnd_esm_js"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom")]).then(() => (() => (__webpack_require__(54568))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "13.1.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-beautiful-dnd",
	}
};
var initialConsumes = [78286];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
var chunkMapping = {
	"main": [
		78286
	],
	"webpack_sharing_consume_default_react-dom_react-dom": [
		56370
	],
	"webpack_sharing_consume_default_react-router-dom_react-router-dom": [
		1973
	],
	"webpack_sharing_consume_default_react-i18next_react-i18next": [
		81217
	],
	"apps_console-host_src_main_tsx": [
		65201,
		73780
	],
	"webpack_sharing_consume_default_clsx_clsx-webpack_sharing_consume_default_date-fns_date-fns": [
		98987,
		99277
	],
	"packages_dxp-console-support_dist_mjs_index_js": [
		27897,
		73385
	],
	"libs_sds_src_index_ts": [
		44213,
		64153,
		80076,
		58777,
		97749,
		94743,
		50666,
		83402,
		81341,
		43638,
		82013,
		48295,
		62204
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}